/**
 * 邮箱
 */
function isEmail(content) {
    return /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(content)
}

export function checkEmail(rule, value, callback) {
    if (!isEmail(value)) {
        callback(new Error('邮箱格式错误'))
    } else {
        callback()
    }
}

